(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eu-legal-guarantee"] && !Shopify.designMode) return;
  try {
    const dialog = document.querySelector('[data-eu-guarantee-dialog]');
  const openButton = document.querySelector('[data-eu-guarantee-open]');
  const closeButton = document.querySelector('[data-eu-guarantee-close]');

  if (dialog && openButton && closeButton) {
    openButton.addEventListener('click', () => dialog.showModal());
    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
